import CommonStyles from 'shared/style/commonPageStyles'
import styled from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,

	ContainerDiv: styled.div`
		display: flex;
		gap: 20px;
	`,
	AreaDiv: CommonStyles.AreaDiv,

	SliderDiv: styled.div`
		width: 400px;
		display: flex;
		align-items: center;
		justify-content: end;
		gap: 4px;

		& > button {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 24px;
			height: 24px;
			background-color: ${({theme}) => theme.color.grey1};
			border-radius: 4px;

			& > img {
				height: 12px;
			}
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			max-width: 100%;
		}
	`,
	ContentImg: styled.img`
		width: 400px;
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			max-width: 100%;
		}
	`,
}

export default Style
